(() => {
  const ObserveIntersection = (elementSelector, config, callback) => {
    var observer = new IntersectionObserver(callback, config);
    let $selector = document.querySelector(elementSelector)
    if (!$selector) return;
    observer.observe($selector, config);
  
    return observer;
  }
  
  const AddItemsToCart = (itemsToAdd, sections, callback) => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        items: itemsToAdd,
        sections: sections || ''
      })
    })
    .then((res) => res.json()).then((res) => {
      if (callback && typeof callback == 'function') {
        callback(res);
      }
    })
    .catch(console.error);
  }

  const StringToHTML = (text) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(text, 'text/html');
    return doc.body;
  }

  const ScrollStop = (callback) => {
    // Make sure a valid callback was provided
    if (!callback || typeof callback !== 'function') return;
  
    // Setup scrolling variable
    var isScrolling;
  
    // Listen for scroll events
    window.addEventListener('scroll', function (event) {
      // Clear our timeout throughout the scroll
      window.clearTimeout(isScrolling);
  
      // Set a timeout to run after scrolling ends
      isScrolling = setTimeout(function() {
        // Run the callback
        callback();
      }, 100);
    }, false);
  }
  
  const Announcements = () => {
    document.querySelectorAll('.announcementSwiper').forEach(($section) => {
      if ($section.dataset.length <= 1) return;

      let autoplay = JSON.parse($section.dataset.autoplay) || false;

      let swiper = new Swiper($section, {
        loop: true,
        speed: 500,
        autoplay: autoplay,
        navigation: {
          nextEl: $section.querySelector('.swiper-button-next'),
          prevEl: $section.querySelector('.swiper-button-prev')
        },
        on: {
          init() {
            document.dispatchEvent(new CustomEvent('theme:rimg:watch'));
          }
        }
      });
    });
  }

  const ToggleHeaderSearch = () => {
    document.querySelectorAll('button.header-search-button').forEach(($searchBtn) => {
      $searchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        let $form = $searchBtn.closest('form');
        let $searchBar = $searchBtn.previousElementSibling;
        if (!$form.classList.contains('visible')) {
          $form.classList.add('visible');
          $searchBar.focus();
        }
        else {
          $form.submit();
        }
      });
    });

    document.querySelectorAll('button.header-search-button-close').forEach(($closeBtn) => {
      $closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        let $form = $closeBtn.closest('form');
        $form.classList.remove('visible');
      });
    });

    document.addEventListener('click', (e) => {
      if (e.target.getAttribute('className') && e.target.getAttribute('className').indexOf('header-search-input') == -1) {
        document.querySelector('.header-search-input').classList.remove('visible');
      }
    });
  }

  const ProductStickyForm = () => {
    document.querySelectorAll('.product-add-to-cart.sticky').forEach(($sticky_form) => {
      let offset = 175;
      ScrollStop(() => {
        let $mainAtc = document.querySelector('.product-add-to-cart');
        let FormInView = window.scrollY <= $mainAtc.offsetTop + offset;
        let isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (isMobile) {
          $sticky_form.classList.toggle('visible', !FormInView);
        }
      });

      $sticky_form.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        let $mainAtc = document.querySelector('.product-add-to-cart');
        window.scrollTo({
          top: $mainAtc.offsetTop - offset,
          behavior: 'smooth'
        });
      });
    });
  }

  const ProductFormLoad = () => {
    let isProductPage = document.querySelector('.template-product');
    if (!isProductPage) return;

    document.querySelectorAll('.select-wrapper').forEach(($selectWrap) => {
      if (window.getComputedStyle($selectWrap).display !== "none") {
        let $select = $selectWrap.querySelector('.single-option-selector');
        $select.value = 'select';
        $select.dispatchEvent(new Event('change'));
  
        let $option1 = $select.querySelector('option:first-of-type');
        $option1.disabled = true;  
      }
    });

  }

  const ProductSizeGuide = () => {
    document.querySelectorAll('.size-guide-link').forEach(($link) => {
      $link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        Fancybox.show([{ src: '#size-chart-modal', type: 'inline' }]);
      });
    });
  }

  const ShippingProgressBar = () => {
    document.querySelectorAll('.shipping-progress-bar').forEach(($bar) => {
      var progressbar = new ProgressBar.Line($bar, {
        strokeWidth: 3,
        easing: 'easeInOut',
        duration: 700,
        color: $bar.dataset.progressbarColor,
        trailColor: $bar.dataset.progressbarTrailColor,
        trailWidth: $bar.dataset.progressbarWidth,
        svgStyle: {width: '100%', height: '100%'}
      });

      document.addEventListener('shipping:progress:update', (e) => {
        let cartTotal = parseFloat($bar.dataset.cartTotal);
        let minTotal = parseFloat($bar.dataset.minTotal);
        let percent = cartTotal / minTotal;
        if (percent > 1) {
          percent = 1;
        }
        progressbar.animate(percent);

        let $message = $bar.closest('.shipping-progress-wrap').querySelector('.shipping-progress-message');
        let formatted_amount = window.Theme.Currency.formatMoney(minTotal - cartTotal).replace('.00', '');
        let message_complete = $bar.dataset.messageComplete;
        let message_incomplete = $bar.dataset.messageIncomplete.replaceAll('{$amount}', formatted_amount);
        
        let message = (cartTotal >= minTotal) ? message_complete : message_incomplete;
        $message.textContent = message;
      });

      document.dispatchEvent(new CustomEvent('shipping:progress:update'));
    });
  }

  const CollectionFilters = () => {
    let $filtersMenu = document.querySelector('.collection-dropdown--filter');

    let GetActiveFilters = () => {
      let active_filters = [];
      document.querySelectorAll('[data-filter-group-list]').forEach(($group) => {
        let active_items = Array.from($group.querySelectorAll('[data-filter-active]')).map(($active) => {
          return $active.dataset.value;
        });
        
        let group = {
          name: $group.querySelector('[data-name]').dataset.name,
          active_items: active_items
        };
        active_filters.push(group);
      });

      //console.log(active_filters);

      return active_filters;
    }

    let ApplyFilters = () => {
      let active_filters = GetActiveFilters();

      let collection_handle = window.location.pathname;
      let filter_parts_url = active_filters.map((item) => {
        return item.active_items.map((active_item_value) => `${ item.name }=${ active_item_value }`).join('&')
      });
      filter_parts_url = filter_parts_url.filter((item) => item).join('&');
      
      let url = `${ collection_handle }?${ filter_parts_url }`;
      fetch(url)
      .then((res) => res.text())
      .then((res) => {
        let $res = StringToHTML(res);
        let $products = $res.querySelectorAll('.product-list-item');
        let $productsListing = document.querySelector('.collection-products');
        $productsListing.innerHTML = '';
        $products.forEach(($product) => {
          $productsListing.insertAdjacentElement('beforeend', $product);
        });

        document.dispatchEvent(new CustomEvent('products:loaded'));
        document.dispatchEvent(new CustomEvent('theme:rimg:watch'));

        $filtersMenu.classList.remove('visible');

        let $clearFilterBtn = document.querySelector('button[data-clear-filters]');
        if ($clearFilterBtn) {
          $clearFilterBtn.classList.toggle('active', filter_parts_url !== '');
        }  

        // set url
        window.history.replaceState({path: url}, '', url);

        // active filters
        $filtersMenu.querySelector('.active-filters-wrap').innerHTML = $res.querySelector('.active-filters-wrap').innerHTML;

        // active filters count
        let active_filters_count = active_filters.map(filter => filter.active_items).reduce((sum, item) => sum += item.length , 0);
        document.querySelectorAll('.btn-open-filters .active-count').forEach(($count) => {
          $count.textContent = active_filters_count > 0 ? `(${ active_filters_count })` : '';
        });

        // pagination
        let $pagination = document.querySelector('.pagination');
        if ($pagination) {
          let $res_pagination = $res.querySelector('.pagination');
          $pagination.innerHTML = $res_pagination ? $res_pagination.innerHTML : '';
        }

        InitEvents();
      });
    }

    let InitEvents = () => {
      // toggle filter menu
      document.querySelectorAll('[data-toggle-filter]:not(.initialized)').forEach(($btn) => {
        $btn.addEventListener('click', (e) => {
          e.preventDefault();
          $filtersMenu.classList.toggle('visible');
        });
        $btn.classList.add('initialized');
      });

      // prevent default redirect when filter selected
      let filter_close_T;
      document.querySelectorAll('.collection-filters__filter-link:not(.initialized)').forEach(($filterLink) => {
        $filterLink.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // close open dropdown
          clearTimeout(filter_close_T);
          filter_close_T = setTimeout(() => {
            ApplyFilters();
          }, 500);
        });
        $filterLink.classList.add('initialized');
      });

      // Filter apply button 
      document.querySelectorAll('[data-apply-filter]:not(.initialized)').forEach(($applyFilter) => {
        $applyFilter.addEventListener('click', (e) => {
          ApplyFilters();
        });
        $applyFilter.classList.add('initialized');
      });

      // Remove filter item
      document.querySelectorAll('.active-filter-group__item:not(.initialized)').forEach(($item) => {
        $item.addEventListener('click', (e) => {
          e.preventDefault();
          let value = e.currentTarget.dataset.value;
          document.querySelectorAll(`.collection-filters__filter-link[data-value="${ value }"]`).forEach(($activeItem) => { 
            $activeItem.querySelector('[data-checked]').removeAttribute('data-checked');
            $activeItem.closest('[data-filter-active]').removeAttribute('data-filter-active');
            ApplyFilters();
          });
        });
      });

      // Clear all
      document.querySelectorAll('[data-clear-filters]:not(.initialized)').forEach(($clearBtn) => {
        $clearBtn.addEventListener('click', (e) => {
          e.preventDefault();

          document.querySelectorAll('.collection-filters__filter-checkbox[data-checked]').forEach(($activeItem) => {
            $activeItem.removeAttribute('data-checked');
            $activeItem.closest('[data-filter-active]').removeAttribute('data-filter-active');
          });

          ApplyFilters();
        });
        $clearBtn.classList.add('initialized');
      });
    }

    let ReorderSizeList = () => {
      let size_list_order = ['2T', '3T', '4T', '5', '6', '7', '8', '10', '12', '14', '16', '1SIZE', 'XS', 'S', 'S/M', 'M', 'L', 'L/XL', 'XL', '6_12', '12_18', '18_24'];
      size_list_order = size_list_order.map((item) => {
        return {
          value: item,
          $el: document.querySelector(`.collection-filters__filter-list-item[data-value="${ item }"]`)
        }
      });

      document.querySelectorAll('[data-filter="Size"]').forEach(($container) => {
        $container.innerHTML = '';

        size_list_order.forEach((item) => {
          if (item.$el) {
            $container.insertAdjacentElement('beforeend', item.$el);
          }
        });
      });
    }

    InitEvents();
    ReorderSizeList();
  }

  let UpdateCartItemsCount = (itemCount) => {
    document.querySelectorAll('.cart-item-count').forEach(($count) => {
      $count.innerText = itemCount;
      $count.classList.toggle('hidden', itemCount == 0);
    });
  }

  const CartUpsells = () => {
    let InitUpsellsSwiper = ($container) => {
      let $swiper = $container.querySelector('.upsells-swiper')
      var upsells_swiper = new Swiper($swiper, {
        pagination: {
          el: $swiper.querySelector('.swiper-pagination'),
          clickable: true
        },
        on: {
          init() {
            document.dispatchEvent(new CustomEvent('wrap:select'));
          }
        }
      });
    }

    let MiniCartRefresh = (cartResponse) => {
      let $res_header = StringToHTML(cartResponse.sections.header);
      let $res_miniCart = $res_header.querySelector('.mini-cart');
      let $miniCart = document.querySelector('.mini-cart');
      $miniCart.innerHTML = $res_miniCart.innerHTML;
      $upsellsContainer = $miniCart.querySelector('.cart-upsells');

      let cart_item_count = $res_header.querySelector('.cart-item-count').textContent;
      UpdateCartItemsCount(cart_item_count);

      InitUpsellsSwiper($upsellsContainer);
      InitUpsellsForms(($upsellsContainer));

      $miniCart.closest('.mini-cart-wrapper').classList.remove('visible');
    }

    let RefreshCartPage = () => {
      window.location.reload();
    }

    let InitUpsellsForms = ($container) => {
      let $miniCartWrap = $container.closest('.mini-cart-wrapper');
      $container.querySelectorAll('select[name=id]').forEach(($select) => {
        $select.addEventListener('change', (e) => {
          let $form = $select.closest('.upsell-form-wrap');
          let $btnAddToCart = $form.querySelector('.upsell-add-to-cart');
          $btnAddToCart.classList.remove('disabled');

          if ($miniCartWrap) {
            $miniCartWrap.classList.add('visible');
          }
        });
      });

      $container.querySelectorAll('.upsell-add-to-cart').forEach(($btnAddToCart) => {
        $btnAddToCart.addEventListener('click', (e) => {
          e.preventDefault();
          let $form = $btnAddToCart.closest('.upsell-form-wrap');
          let $select = $form.querySelector('select[name=id]');
          let variant_id = $select.value;

          let itemsToAdd = [
            {
              quantity: 1,
              id: variant_id,
              properties: {}
            }
          ];
          let sections = 'header';

          let isCartPage = document.body.classList.contains('template-cart');
          let cartRefresh = isCartPage ? RefreshCartPage : MiniCartRefresh;

          AddItemsToCart(itemsToAdd, sections, cartRefresh);
        });
      });
    }

    document.querySelectorAll('.cart-upsells').forEach(($upsellsContainer) => {
      InitUpsellsSwiper($upsellsContainer);
      InitUpsellsForms($upsellsContainer);
    });
  }

  const CollectionsListSwiper = () => {
    let InitCollectionsListSwiper = () => {
      document.querySelectorAll('.home-collections-content-swiper').forEach(($swiperContainer) => {
        let isCollectionPage = document.querySelector('.template-collection') !== undefined;
        let showNavArrows = JSON.parse($swiperContainer.dataset.enable_nav_arrows);
        let swiperConfig = {
          slidesPerView: isCollectionPage ? 3.5 : 1.45,
          spaceBetween: 15,
          loop: true,
          breakpoints: {
            540: {
              slidesPerView: isCollectionPage ? 4.5 : 2.25,
              spaceBetween: 20    
            },
            900: {
              slidesPerView: isCollectionPage ? 4.5 : 3.6,
              spaceBetween: 25
            }
          },
          on: {
            init() {
              // load images on cloned slides
              document.dispatchEvent(new CustomEvent('theme:rimg:watch'));
            }
          }
        };

        if (showNavArrows) {
          swiperConfig.navigation = {
            nextEl: $swiperContainer.querySelector('.swiper-button-next'),
            prevEl: $swiperContainer.querySelector('.swiper-button-prev')
          }
        }
        
        new Swiper($swiperContainer, swiperConfig);
      });  
    }

    InitCollectionsListSwiper();

    document.addEventListener('shopify:section:unload', (e) => {
      setTimeout(InitCollectionsListSwiper, 10);
    });
  }

  const LogosSwiper = () => {
    document.querySelectorAll('.logos-swiper').forEach(($swiperContainer) => {
      let swiper = new Swiper($swiperContainer, {
        slidesPerView: 2.5,
        spaceBetween: 25,
        centerInsufficientSlides: true,
        breakpoints: {
          540: {
            slidesPerView: 3.5,
            spaceBetween: 35
          },
          900: {
            slidesPerView: 4.25,
            spaceBetween: 45
          }
        }
      });
    })
  }
 
  const FeaturedProductsTabs = () => {
    let InitSection = () => {
      document.querySelectorAll('.home-products-content-swiper:not(.swiper-initialized)').forEach(($swiperContainer) => {
        let showNavArrows = JSON.parse($swiperContainer.dataset.enable_nav_arrows);
        let swiperConfig = {
          slidesPerView: 1.45,
          spaceBetween: 0,
          breakpoints: {
            540: {
              slidesPerView: 2.25,
              spaceBetween: 0    
            },
            900: {
              slidesPerView: 3.6,
              spaceBetween: 0
            }
          }
        };

        if (showNavArrows) {
          swiperConfig.navigation = {
            nextEl: $swiperContainer.querySelector('.swiper-button-next'),
            prevEl: $swiperContainer.querySelector('.swiper-button-prev')
          }
        }
        let swiper = new Swiper($swiperContainer, swiperConfig);
      });  

      document.querySelectorAll('.home-products-tabs').forEach(($section) => {
        let $tabs = $section.querySelectorAll('.tabs li');
        let $productsWrap = $section.querySelectorAll('.home-products-content-tabs');
    
        $tabs.forEach(($tab) => {
          $tab.addEventListener('click', (e) => {
            $tabs.forEach(($item) => {
              $item.classList.remove('active');
            });
            $tab.classList.add('active');
    
            let index = JSON.parse($tab.dataset.index);
            $productsWrap.forEach(($container) => {
              $container.classList.remove('active');
            });
            $productsWrap[index].classList.add('active');
          });
        });  
      });
    }

    InitSection();
    document.addEventListener('shopify:section:unload', (e) => {
      console.log(e);
      setTimeout(InitSection, 0);
    });

    document.addEventListener('shopify:block:select', (e) => {
      console.log(e);
      setTimeout(InitSection, 0);
    });
  }

  const StickyCartMobile = () => {
    let offset = 125;
    let isMobile = window.matchMedia("(max-width: 768px)");
    ScrollStop(() => {
      let offsetTop = window.pageYOffset;
      let $headerIcon = document.querySelector('.header-cart-icon-active');
      document.body.classList.toggle('sticky-cart', isMobile && offsetTop >= offset);
    });
  }

  const BackToTop = () => {
    ScrollStop(() => {
      let offsetTop = window.pageYOffset;
      let $backToTop = document.querySelector('.back-to-top');
      if (!$backToTop) return;

      $backToTop.classList.toggle('visible', offsetTop > document.body.clientHeight / 3);

      $backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      });
    });
  }

  const FooterPromotionsSwiper = () => {
   let swipers = [];
   InitSwiper = () => {
    document.querySelectorAll('.footer-promotions-swiper:not(.swiper-initialized)').forEach(($swiperContainer) => {
      let swiperConfig = {
        slidesPerView: 1.35,
        spaceBetween: 25,
        breakpoints: {
          540: {
            slidesPerView: 2.25,
            spaceBetween: 10 
          }
        }
      };

      swipers.push(new Swiper($swiperContainer, swiperConfig));
    });
   }

   DestroySwiper = () => {
    swipers.forEach((swiper) => {
      swiper.destroy();
    });
   }

   let breakpoint = window.matchMedia('(max-width: 900px)');
   breakpoint.addEventListener('change', (e) => {
    e.matches ? setTimeout(InitSwiper, 100) : setTimeout(DestroySwiper, 100);
   });

   if (breakpoint.matches) {
    InitSwiper();
   }
  }

  const DescriptionReadMore = () => {
    document.querySelectorAll('.collection-description.enable-read-more').forEach(($section) => {
      //console.log($section.querySelector('[data-readmore]'));
      $section.querySelector('[data-readmore]').addEventListener('click', (e) => {
        e.preventDefault();
        $section.classList.toggle('visible');
        e.currentTarget.textContent = $section.classList.contains('visible') ? 'Read Less' : 'Read More';
      });
    });
  }

  const MiniCartMobile = () => {
    var isMobile = window.matchMedia("(max-width: 767px)").matches;
    var $miniCartWrap = document.querySelector('.mini-cart-wrapper');
    if (isMobile) {
      document.querySelectorAll('.minicart-close').forEach(($closeBtn) => {
        $closeBtn.addEventListener('click', (e) => {
          $miniCartWrap.classList.remove('visible');
        });
      });
  
      document.querySelectorAll('.header-cart-icon a').forEach(($cartIcon) => {
        $cartIcon.addEventListener('click', (e) => {
          e.preventDefault();
          $miniCartWrap.classList.add('visible');
        });
      });
    }
  }

  const ProductsSwiper = () => {
    let InitSwiper = () => {
      document.querySelectorAll('.products-grid-swiper:not(.swiper-initialized)').forEach(($swiperContainer) => {
        let loop = $swiperContainer.dataset.loop;
        loop = loop ? (loop == 'true') : false;
        let isCollectionPage = document.querySelector('.template-collection') !== undefined;
        let showNavArrows = true;
        let swiperConfig = {
          slidesPerView: 1.5,
          spaceBetween: 15,
          loop: loop,
          breakpoints: {
            540: {
              slidesPerView: isCollectionPage ? 3.5 : 2.25,
              spaceBetween: 20    
            },
            900: {
              slidesPerView: isCollectionPage ? 4.5 : 3.6,
              spaceBetween: 25
            }
          },
          on: {
            init() {
              document.dispatchEvent(new CustomEvent('theme:rimg:watch'));
            }
          }
        };

        if (showNavArrows) {
          swiperConfig.navigation = {
            nextEl: $swiperContainer.querySelector('.swiper-button-next'),
            prevEl: $swiperContainer.querySelector('.swiper-button-prev')
          }
        }
        
        new Swiper($swiperContainer, swiperConfig);
      });  
    }

    document.addEventListener('shopify:section:unload', (e) => {
      setTimeout(InitSwiper, 10);
    });

    document.addEventListener('recommendations:loaded', (e) => {
      setTimeout(InitSwiper, 10);
    });
    document.addEventListener('recently-viewed:loaded', (e) => {
      setTimeout(InitSwiper, 10);
    });
  }

  const ProductTiles = () => {
    let $tile = document.querySelector('.product-tile-item');
    if (!$tile) return;
    window.onscroll = () => {
      let isTileInView = window.scrollY <= ($tile.offsetTop + ($tile.offsetHeight * 2))
      $tile.classList[isTileInView ? 'remove' : 'add']('visually-hidden');
    }
    ObserveIntersection('.product-tile-item', {}, (entries) => {
      let entry = entries[0];
    });
  }

  const DOMReady = () => {
    Announcements();
    ToggleHeaderSearch();
    ProductFormLoad();
    ProductStickyForm();
    ProductSizeGuide();
    ShippingProgressBar();
    CollectionFilters();
    CartUpsells();
    CollectionsListSwiper();
    LogosSwiper();
    FeaturedProductsTabs();
    StickyCartMobile();
    BackToTop();
    FooterPromotionsSwiper();
    DescriptionReadMore();
    MiniCartMobile();
    ProductsSwiper();
    ProductTiles();
  }

  const CartUpdated = (e) => {
    // update cart events
    if (e.detail.data.itemCount) {
      let itemCount = e.detail.data.itemCount;
      UpdateCartItemsCount(itemCount);
    }

    // update shipping progress 
    document.querySelectorAll('.shipping-progress-bar').forEach(($bar) => {
      $bar.dataset.cartTotal = e.detail.data.total_price;
      document.dispatchEvent(new CustomEvent('shipping:progress:update'));
    });
  };

  document.addEventListener('DOMContentLoaded', DOMReady);
  document.addEventListener('cart:updated', CartUpdated);
})();